"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Disclaimer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _merchButton = require("@site/pattern-library-core/merch-button");
/** @module Disclaimer */

const DisclaimerLink = /*#__PURE__*/(0, _react2.styled)(_merchButton.NSMerchButton)({
  name: "DisclaimerLink",
  class: "pl-d8yvb4v"
});

/**
  * Render disclaimer string.
  *
  * @param {object} props React props for element
  * @param {string} props.href Url for the link
  * @param {string} props.text Text that triggers disclaimer modal
  * @param {string} props.symbols Additional symbols for clarification
  * @param {function} props.onClick Optional button click handler
  * @param {string} props.triggerEid Trigger eid (legacy - use _name instead)
  * @param {string} props._name Content name for modern tracking
  * @param {string} props.triggerDescription Text below trigger
  * @returns {React.ReactElement} DisclaimerModal component
  * @public
  */
function Disclaimer({
  href,
  text,
  symbols = '',
  onClick,
  triggerEid,
  _name
}) {
  // Use _name for modern tracking, fallback to triggerEid for legacy
  const legacyProps = !_name && triggerEid ? {
    'data-eid': triggerEid
  } : {};
  return /*#__PURE__*/_react.default.createElement(DisclaimerLink, (0, _extends2.default)({
    design: "inline",
    href: href
  }, _name && {
    _name: `${_name}-trigger`
  }, legacyProps, {
    "data-cy": "disclaimer-trigger",
    target: "_blank",
    onClick: onClick,
    isPromo: false
  }), symbols && /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "disclaimer-symbols"
  }, `${symbols} `), /*#__PURE__*/_react.default.createElement("strong", null, text));
}
Disclaimer.propTypes = {
  href: _propTypes.default.string,
  text: _propTypes.default.string,
  symbols: _propTypes.default.string,
  onClick: _propTypes.default.func,
  triggerEid: _propTypes.default.string,
  _name: _propTypes.default.string
};